import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Typography, message, Divider, Badge, Tabs } from "antd";
import { CarryOutOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate, useSearchParams } from "react-router-dom";
import http from "../../services/http";
import { AuthContext } from "../../contexts/AuthContext";
import { ProblemasTable } from "./components/problemas-table";
import { ProblemasRelatorioTable } from "./components/problemas-relatorio-table";
import { ProblemasAvaliacoesTable } from "./components/problemas-avaliacoes-table";
const { Text } = Typography;

export const Problemas = () => {
  const navigate = useNavigate();
  const { session, verificarAcesso } = useContext(AuthContext);
  const [pendenciasAvaliacoes, setPendenciasAvaliacoes] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") ?? "1";

  useEffect(() => {
    listarPendenciasAvaliacoes();
  }, []);

  const listarPendenciasAvaliacoes = async () => {
    const api = await http("get", `v1/problemas/listar_pendencias`, []);
    if (api.statusCode === 200) {
      setPendenciasAvaliacoes(api.response.data);
    } else {
      message.error(api.response.message);
    }
  };

  const tab_options = [
    {
      key: "1",
      label: "Meus Planos de Ação",
      children: <ProblemasTable idColaborador={session.usuario.id_colaborador} />,
    },
    verificarAcesso("PLANO_ACAO_AVALIACAO") && {
      key: "2",
      label: (
        <>
          Minhas Avaliações <Badge count={pendenciasAvaliacoes} />
        </>
      ),
      children: <ProblemasAvaliacoesTable onChangeStatus={() => listarPendenciasAvaliacoes()} />,
    },
    verificarAcesso("PLANO_ACAO_RELATORIOS") && {
      key: "3",
      label: "Planos de Ação Setor/Filial",
      children: <ProblemasRelatorioTable />,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={24} lg={24} xl={23} xxl={20} align="left">
        <div className="content-item">
          <HeaderPage title="Planos de Ação" onClickBack={() => navigate("/")} />
          <HeaderTitle title="Planos de Ação" subtitle="Meus Planos de Ação" icon={<CarryOutOutlined />} />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <Tabs
              type="card"
              activeKey={tab}
              items={tab_options}
              onTabClick={(val) =>
                setSearchParams((state) => {
                  state.set("tab", val);
                  return state;
                })
              }
            />
          </Card>
        </div>
      </Col>
    </Row>
  );
};
